import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { OfferingDocumentFormat } from '@arrived/models';

export const formatOfferingDocumentFormatType = (type: OfferingDocumentFormat | string): ReactNode => {
  switch (type) {
    case OfferingDocumentFormat.PDF:
      return <FormattedMessage id="offering-document-format-pdf" defaultMessage="PDF" />;
    case OfferingDocumentFormat.URL:
      return <FormattedMessage id="offering-document-format-url" defaultMessage="URL" />;
    default:
      return '';
  }
};
